module.exports = __webpack_public_path__ + "static/media/favicon.19799e32.svg";